import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const onActivationLogin = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.activationLogin(values.activation_code);
      const { access_token, refresh_token, activation_code } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      localStorage.setItem('username', response.data.username || '激活用户');
      if (activation_code) {
        localStorage.setItem('activation_code', activation_code);
      }
      message.success('激活码登录成功');
      navigate('/dashboard', { replace: true });
    } catch (error) {
      message.error(error.response?.data?.detail || '激活码登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#0d1117',
      padding: isMobile ? '16px' : '0'
    }}>
      <Card style={{ 
        width: isMobile ? '100%' : 450,
        maxWidth: isMobile ? '400px' : 'none',
        boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
        background: '#161b22',
        border: '1px solid #30363d',
        borderRadius: isMobile ? '8px' : '6px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? 20 : 24 }}>
          <Title level={isMobile ? 3 : 2} style={{ 
            marginBottom: 8,
            color: '#58a6ff',
            fontWeight: 'bold'
          }}>XiaBO</Title>
          <Text style={{ 
            color: '#8b949e',
            fontSize: isMobile ? '14px' : '16px'
          }}>激活码登录系统</Text>
        </div>

        <Form
          name="activation_login"
          onFinish={onActivationLogin}
          autoComplete="off"
          layout="vertical"
          style={{ marginTop: 24 }}
        >
          <Form.Item
            name="activation_code"
            rules={[
              { required: true, message: '请输入激活码' },
              { min: 8, message: '激活码至少8位' }
            ]}
          >
            <Input
              prefix={<KeyOutlined style={{ color: '#8b949e' }} />}
              placeholder="请输入激活码"
              size="large"
              className="dark-input"
              style={{ 
                height: 48,
                background: '#21262d !important',
                border: '1px solid #30363d !important',
                color: '#e6edf3 !important'
              }}
              styles={{
                input: {
                  color: '#e6edf3 !important',
                  '::placeholder': {
                    color: '#ffffff !important',
                    opacity: 1
                  }
                }
              }}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 32 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
              style={{ 
                height: 48,
                background: '#238636',
                border: '1px solid #238636'
              }}
            >
              激活并登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
